import { getStoryblokApi } from '@storyblok/react'
import { isNotFoundError } from './isNotFoundError'
import { PageStory } from './types'

export async function fetchPage(slug: string, preview?: boolean): Promise<PageStory | null> {
  const storyblok = getStoryblokApi()

  try {
    const { data } = await storyblok.get(`cdn/stories/${slug}`, {
      version: preview ? 'draft' : 'published',
      resolve_links: 'story',
    })

    return data.story
  } catch (error) {
    if (isNotFoundError(error)) {
      return null
    }

    console.error(`Failed to fetch page "${slug}" from Storyblok:`, error)
    throw error
  }
}
